import React, { useState } from "react";
import {
  Button,
  FormFieldSet,
  LoopFieldsSet,
  Modal,
  useFormHandler,
} from "../../../../../components";
import { IndustryOptions } from "../../../../../assets/data/enumData";
import { v4 as uuidv4 } from "uuid";
const options = [
  { label: "Mohsin Usman", value: 1 },
  { label: "Raghuveer Bandi", value: 2 },
];

const AddVmsModal = ({ isOpen, onClose }) => {
  const [reports, setReports] = useState([]);
  const addReports = () => {
    const newReport = {
      id: uuidv4(),
      customer: "",
      additionalRecruiter: "",
      recruiters: "",
      AccountManager: "",
      clientContactName: "",
    };

    setFormData({
      ...formData,
      reports: [...formData.reports, newReport],
    });
  };

  const removeReports = (reportId) => {
    if (formData.reports.length > 1) {
      const updatedReports = formData.reports.filter(
        (report) => report.id !== reportId
      );
      setFormData({
        ...formData,
        reports: updatedReports,
      });
    }
  };

  const initialData = {
    reports: [
      {
        customer: "",
        additionalRecruiter: "",
        recruiters: "",
        AccountManager: "",
        clientContactName: "",
      },
    ],
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialData, {});
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={"Add VMS"}
      titleColor={"primary"}
      width="max-w-7xl"
    >
      <div className="p-2">
        <div className="border border-gray-200 rounded-sm grid grid-cols-3 gap-5 p-4 mb-4">
          <FormFieldSet title="Visa Type" placeholder="Visa Type" required />
          <FormFieldSet title="User Name" placeholder="User Name" />
          <FormFieldSet title="Password" placeholder="Password" required />
          <FormFieldSet title="Client URL" placeholder="Client URL" />
          <FormFieldSet title="Customer Name" placeholder="Customer Name" />
          <FormFieldSet title="URL" placeholder="URL" />
        </div>
        <h6 className="mb-4">Mapping Fields</h6>
        <div className="border border-gray-200 rounded-sm grid grid-cols-3 gap-5 p-4 mb-4">
          <FormFieldSet title="Customer" placeholder="Customer" required />
          <FormFieldSet title="Status" placeholder="Status" />
          <FormFieldSet
            title="Customer Type"
            placeholder="Select"
            type="select"
            options={[
              { label: "Direct Client", value: 1 },
              { label: "Internal", value: 2 },
              { label: "Primer Vendor", value: 3 },
              { label: "Vendor", value: 4 },
            ]}
            required
          />
          <FormFieldSet
            title="Additional Recruiters"
            placeholder="Select"
            type="multiSelect"
            showSearch
            options={options}
          />
          <FormFieldSet
            title="Account Manager"
            placeholder="Select"
            type="multiSelect"
            showSearch
            options={options}
          />
          <FormFieldSet
            title="Recruitment Manager"
            placeholder="Select"
            type="multiSelect"
            showSearch
            options={options}
          />
          <FormFieldSet
            title="Sourcer"
            placeholder="Select"
            type="multiSelect"
            showSearch
            options={options}
          />
          <FormFieldSet
            title="Interview Panel"
            placeholder="Select"
            type="multiSelect"
            showSearch
            options={options}
          />
          <FormFieldSet
            title="Industry"
            placeholder="Select"
            type="select"
            options={IndustryOptions}
            required
          />
          <FormFieldSet
            title="Priority"
            placeholder="Select"
            type="select"
            options={[
              { label: "High", value: 1 },
              { label: "low", value: 2 },
              { label: "Medium", value: 3 },
            ]}
          />
          <FormFieldSet
            title="Share to Partners"
            placeholder="Select"
            type="select"
            // options={[
            //   { label: "High", value: 1 },
            //   { label: "low", value: 2 },
            //   { label: "Medium", value: 3 },
            // ]}
          />
        </div>
        <h6 className="mb-2">Assignment Type</h6>
        <div className="border border-gray-200 rounded-sm flex flex-col gap-2 p-3 mb-4">
          <FormFieldSet
            type="radio"
            noTitle
            name={""}
            options={[
              { label: "General", value: 1 },
              { label: "Round Robin", value: 2 },
              { label: "Least Assigned", value: 3 },
            ]}
          />
          <FormFieldSet
            title="Recruiters"
            placeholder="Select"
            type="select"
            options={options}
          />
        </div>
        <h6 className="mb-2">Customer Wise Recruiter Mapping Fields</h6>
        <div className="border border-gray-200 rounded-sm  gap-2 p-4 mb-4">
          <LoopFieldsSet
            title=" "
            data={formData.reports}
            gridCols={"grid-cols-3"}
            onAdd={addReports}
            onRemove={removeReports}
            maxItems={3}
            addButtonTitle="Add More"
            renderFields={(report, index) => (
              <>
                <FormFieldSet
                  type="text"
                  title="Customer"
                  placeholder="(e.g. Computer Engineering)"
                  required
                />

                <FormFieldSet
                  type="select"
                  title="Additional Recruiter"
                  placeholder="Select"
                />
                <FormFieldSet
                  type="select"
                  title="Recruiters"
                  placeholder="Select"
                />
                <FormFieldSet
                  type="select"
                  title="Account Manager"
                  placeholder="Select"
                />
                <FormFieldSet
                  type="select"
                  title="Client Contact Name"
                  placeholder="Select"
                />
              </>
            )}
          />
        </div>
        <h6 className="mb-2">Customer Wise Recruiter Mapping Fields</h6>
        <div className="border border-gray-200 rounded-sm  gap-2 p-3 mb-4">
          <FormFieldSet
            type="checkbox"
            noTitle
            options={[
              { label: "Notify the users when VMS Authentication Fails" },
            ]}
          />
          <FormFieldSet
            type="select"
            title="Notify Users"
            placeholder="Select"
            // options={[
            //   { label: "Notify the users when VMS Authentication Fails" },
            // ]}
          />
        </div>
        <div className="flex justify-end gap-4">
          <Button variant="outlined" size="sm" title={"Cancel"} />
          <Button size="sm" title={"Save"} />
        </div>
      </div>
    </Modal>
  );
};

export default AddVmsModal;
